import { Reveal, Eyebrow } from "@/components/Reveal";
import { IMG } from "@/data/content";

const PILLARS = ["Personally Designed", "Handpicked Stays", "One Curator, Start to Finish"];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative overflow-hidden py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-10">
        <div className="relative lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full border border-gold/50" aria-hidden="true" />
              <img
                src={IMG.about}
                alt="Hands sketching a tailor-made journey over maps and journals"
                className="relative h-[420px] w-full object-cover md:h-[560px]"
              />
            </div>
          </Reveal>
          <Reveal delay={0.2} className="relative z-10 mx-6 -mt-16 bg-forest p-7 md:mx-10 md:p-9">
            <p className="font-display text-2xl italic leading-snug text-ivory md:text-[1.7rem]">
              "Every journey begins with a conversation."
            </p>
            <div className="mt-6 flex items-center gap-4">
              <span className="h-px w-10 bg-gold" aria-hidden="true" />
              <div>
                <p className="font-display text-lg text-gold">Pritha Samanta</p>
                <p className="text-[10px] uppercase tracking-widest2 text-ivory/60">Founder | Travel Curator</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 lg:pt-10">
          <Reveal>
            <Eyebrow>About Mirevaa</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 text-4xl leading-[1.15] text-forest md:text-5xl">
              Born from a love of <span className="italic text-gold">beautiful journeys.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-forest-mist md:text-base">
              <p>
                Mirevaa Journeys began with a simple conviction: that the way we travel should be as individual as the
                reason we go. Not packages off a shelf, but journeys composed — around dreams, interests and the way
                you most love to move through the world.
              </p>
              <p>
                We are a boutique travel studio, by design. Every itinerary is personally crafted — researched slowly,
                refined carefully and arranged with partners who share our obsession with detail. From a first
                conversation to the flight home, you have one dedicated curator who knows your journey intimately.
              </p>
              <p>
                For couples at the start of something, families making time count, and celebrations that deserve
                extraordinary settings — Mirevaa exists to make travel feel personal again.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-10 space-y-4">
              {PILLARS.map((p) => (
                <div key={p} className="flex items-center gap-4">
                  <span className="h-px w-8 bg-gold" aria-hidden="true" />
                  <span className="text-xs uppercase tracking-widest2 font-medium text-forest">{p}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
